module.exports = __webpack_public_path__ + "media/assets/login/icon-jazz-5a91e23bb078cd14dd4bcbb4f5ef088c.svg";